import React from "react";

type GridLayerProps = { width: number; height: number; viewBox?: {x:number;y:number;width:number;height:number} };

// Pattern coordinates stay in model space; the viewport controls coverage only.
const GridLayer = ({ width, height, viewBox }: GridLayerProps) => {
  const bounds = viewBox || {x:0,y:0,width,height};
  const step = 10 ** Math.floor(Math.log10(bounds.width / 30));
  return <g data-testid="sketchmath-grid" className="sketchmath-grid" pointerEvents="none">
    <defs>
      <pattern id="sketchmath-grid-pattern" width={step} height={step} patternUnits="userSpaceOnUse">
        <path fill="none" d={`M ${step} 0 H 0 V ${step}`} className="sketchmath-grid-minor" vectorEffect="non-scaling-stroke" />
      </pattern>
      <pattern id="sketchmath-grid-major-pattern" width={step*5} height={step*5} patternUnits="userSpaceOnUse">
        <path fill="none" d={`M ${step*5} 0 H 0 V ${step*5}`} className="sketchmath-grid-major" vectorEffect="non-scaling-stroke" />
      </pattern>
    </defs>
    <rect data-testid="grid-coverage" x={bounds.x-bounds.width*2} y={bounds.y-bounds.height*2} width={bounds.width*5} height={bounds.height*5} fill="url(#sketchmath-grid-pattern)" />
    <rect x={bounds.x-bounds.width*2} y={bounds.y-bounds.height*2} width={bounds.width*5} height={bounds.height*5} fill="url(#sketchmath-grid-major-pattern)" />
  </g>;
};
export default GridLayer;
